import React, { useState } from 'react'

// Appt Components
import FontAwesome from '../../components/compound/fontAwesome/FontAwesome'
import OptionButtons from '../../components/compound/optionButtons/OptionButtons'
import Box from '../../components/simple/box/Box'
import Divider from '../../components/simple/divider/Divider'
import Form from '../../components/simple/form/Form.js'
import FormField from '../../components/simple/formField/FormField.js'
import H2 from '../../components/simple/heading/H2.js'
import TextArea from '../../components/simple/input/TextArea'
import Text from '../../components/simple/text/Text'
import TextInput from '../../components/simple/input/TextInput.js'

import CommentsForm from './CommentsForm.js';
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import Button from '../../components/simple/button/Button.js'

import LocalStorageService from '../../services/LocalStorageService.js'

function PostIncidentLearning (props) {
  const [questions, setQuestions] = useState(props.questions)

  const [localIncidentValues, setLocalIncidentValues] = useState(props.incidentValues)

  const activeOrg = LocalStorageService.get('activeOrg')

  const previousPage = () => {
    props.previousPage(localIncidentValues)
  }

  const nextPage = () => {
    props.nextPage(localIncidentValues)
  }

  // Submit form values
  const submitForm = async (values) => {
    props.submitForm(values, 'Draft')
  }
  // auto save every 15 seconds
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     // buildTechniqueArray()
  //     props.submitForm(localIncidentValues, 'Draft')
  //   }, 15000)
  //   return () => clearInterval(interval) // Clear the interval on component unmount
  // }, [])

  return (
    <Box
      gridArea="main"
      background="white"
      direction="column"
      gap="small"
      round="small"
    >
      <Box
        gap="small"
        margin={{ horizontal: 'small' }}
        pad="small"
        round="small"
      >
        <Box fill direction="row" gap="small">
          <H2 margin={{ vertical: 'none' }}>Post Incident Learning</H2>
          <Button
            label={
              <Text>
                <FontAwesome color="brand" icon={['fas', 'question-circle']} />
              </Text>
            }
            plain
            tip={{
              content: (
                <Box
                  background={{ color: 'white' }}
                  border={{ color: 'brand', size: 'small' }}
                  direction="column"
                  pad="small"
                >
                  <Text>
                    Post incident learning should take place as soon as possible
                    but only when staff and service user are ready.
                  </Text>
                </Box>
              ),
            }}
          />
        </Box>

        <Divider color="primary" margin={{ top: 'none', bottom: 'small' }} />
        <Form
          //   validate='blur'
          onChange={nextValue => {
            setLocalIncidentValues(nextValue);
          }}
          onSubmit={({ value: nextValue }) => {
            submitForm(nextValue);
          }}
          value={localIncidentValues}
        >
          <Box>
            <FormField
              label={
                <Box fill direction="row" gap="small">
                  <Text size="small">{questions[3].questionText}</Text>
                  <Button
                    label={
                      <Text>
                        <FontAwesome
                          color="brand"
                          icon={['fas', 'question-circle']}
                        />
                      </Text>
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            Staff should listen to the service users point of
                            view without challenge. Staff should use Empathy,
                            rapport, paraphrasing and summarising. to get a
                            clear idea of what happened.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>
              }
              name={questions[3].key}
              required
            >
              <TextArea name={questions[3].key} type="text" />
            </FormField>
            <FormField
              label={
                <Box fill direction="row" gap="small">
                  <Text size="small">{questions[4].questionText}</Text>
                  <Button
                    label={
                      <Text>
                        <FontAwesome
                          color="brand"
                          icon={['fas', 'question-circle']}
                        />
                      </Text>
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            Staff should try to ascertain how the trigger made
                            the service user feel.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>
              }
              name={questions[4].key}
              required
            >
              <TextArea name={questions[4].key} type="text" />
            </FormField>
            <FormField
              label={
                <Box fill direction="row" gap="small">
                  <Text size="small">{questions[5].questionText}</Text>
                  <Button
                    label={
                      <Text>
                        <FontAwesome
                          color="brand"
                          icon={['fas', 'question-circle']}
                        />
                      </Text>
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            The aim of this process is to plan other strategies
                            that can be implemented by the service user and
                            staff the next time the service user feels the way
                            they feel when they experience the trigger.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>
              }
              name={questions[5].key}
              required
            >
              <TextArea name={questions[5].key} type="text" />
            </FormField>
            <FormField
              label={questions[6].questionText}
              name={questions[6].key}
              required
            >
              <TextArea name={questions[6].key} type="text" />
            </FormField>
            <FormField
              label={questions[7].questionText}
              name={questions[7].key}
            >
              <TextArea name={questions[7].key} />
            </FormField>
            <FormField
              label={questions[8].questionText}
              name={questions[8].key}
            >
              <TextArea name={questions[8].key} />
            </FormField>
{/* 
            <FormField
              label={questions[23].questionText}
              name={questions[23].key}
            >
              <OptionButtons
                id={questions[23].key}
                name={questions[23].key}
                options={['Yes', 'No', "N/A"]}
                value={localIncidentValues.assaultOnStaff || ''}
              />
            </FormField> */}

            {props.enablePILExtras ? (
              <>
                <Divider
                  color="primary"
                  margin={{ top: 'medium', bottom: 'small' }}
                />
                <H2 margin={{ vertical: 'none', bottom: 'small' }}>
                  Discriminatory, Prejudiced and other Behaviour
                </H2>
                <Divider
                  color="primary"
                  margin={{ top: 'none', bottom: 'small' }}
                />

                
                <FormField
                  label={questions[10].questionText}
                  name={questions[10].key}
                  required
                >
                  <OptionButtons
                    id={questions[10].key}
                    name={questions[10].key}
                    value={localIncidentValues[questions[10].key] || 'No'}
                  />
                </FormField>
                <FormField
                  label={questions[11].questionText}
                  name={questions[11].key}
                  required
                >
                  <OptionButtons
                    id={questions[11].key}
                    name={questions[11].key}
                    value={localIncidentValues[questions[11].key] || 'No'}
                  />
                </FormField>
                <FormField
                  label={questions[12].questionText}
                  name={questions[12].key}
                  required
                >
                  <OptionButtons
                    id={questions[12].key}
                    name={questions[12].key}
                    value={localIncidentValues[questions[12].key] || 'No'}
                  />
                </FormField>
                <FormField
                  label={questions[13].questionText}
                  name={questions[13].key}
                  required
                >
                  <OptionButtons
                    id={questions[13].key}
                    name={questions[13].key}
                    value={localIncidentValues[questions[13].key] || 'No'}
                  />
                </FormField>
                <FormField
                  label={questions[14].questionText}
                  name={questions[14].key}
                  required
                >
                  <OptionButtons
                    id={questions[14].key}
                    name={questions[14].key}
                    value={localIncidentValues[questions[14].key] || 'No'}
                  />
                </FormField>
                <FormField
                  label={questions[25].questionText}
                  name={questions[25].key}
                  required
                >
                  <OptionButtons
                    id={questions[25].key}
                    name={questions[25].key}
                    value={localIncidentValues[questions[25].key] || 'No'}
                  />
                </FormField>

                
                <FormField
                  label={questions[15].questionText}
                  name={questions[15].key}
                  required
                >
                  <OptionButtons
                    id={questions[15].key}
                    name={questions[15].key}
                    value={localIncidentValues[questions[15].key] || 'No'}
                  />
                </FormField>

                {/* Assault on Staff */}
                <FormField
                  label={questions[16].questionText}
                  name={questions[16].key}
                  required
                >
                  <OptionButtons
                    id={questions[16].key}
                    name={questions[16].key}
                    value={localIncidentValues[questions[16].key] || 'No'}
                  />
                </FormField>

                {/* Verbal Assault on Staff */}
                {localIncidentValues[questions[16].key] === 'Yes' && <Box direction="column" margin={{ left: 'medium' }} gap="none">
                  <FormField
                    label={questions[26].questionText}
                    name={questions[26].key}
                    required
                  >
                    <OptionButtons
                      id={questions[26].key}
                      name={questions[26].key}
                      value={localIncidentValues[questions[26].key] || 'No'}
                    />
                  </FormField>

                  {/* Physical Assault on Staff */}
                  <FormField
                    label={questions[27].questionText}
                    name={questions[27].key}
                    required
                  >
                    <OptionButtons
                      id={questions[27].key}
                      name={questions[27].key}
                      value={localIncidentValues[questions[27].key] || 'No'}
                    />
                  </FormField>
                </Box>}

                {/* Sexual harassment */}
                {/* Downland school have requested that this is hidden for their service */}
                {activeOrg.id !== 602 && <FormField
                  label={questions[17].questionText}
                  name={questions[17].key}
                  required
                >
                  <OptionButtons
                    id={questions[17].key}
                    name={questions[17].key}
                    value={localIncidentValues[questions[17].key] || 'No'}
                  />
                </FormField>}

                {/* Student On student */}
                <FormField
                  label={questions[18].questionText}
                  name={questions[18].key}
                  required
                >
                  <OptionButtons
                    id={questions[18].key}
                    name={questions[18].key}
                    value={localIncidentValues[questions[18].key] || 'No'}
                  />
                </FormField>

                

                {/* Verbal Assault on Students */}
                {localIncidentValues[questions[18].key] === 'Yes' && <Box direction="column" margin={{ left: 'medium' }} gap="none">
                  <FormField
                    label={questions[28].questionText}
                    name={questions[28].key}
                    required
                  >
                    <OptionButtons
                      id={questions[28].key}
                      name={questions[28].key}
                      value={localIncidentValues[questions[28].key] || 'No'}
                    />
                  </FormField>

                  {/* Physical Assault on Students */}
                  <FormField
                    label={questions[29].questionText}
                    name={questions[29].key}
                    required
                  >
                    <OptionButtons
                      id={questions[29].key}
                      name={questions[29].key}
                      value={localIncidentValues[questions[29].key] || 'No'}
                    />
                  </FormField>
                </Box>}

                {/* Self-injurious Behaviour */}
                <FormField
                  label={questions[19].questionText}
                  name={questions[19].key}
                  required
                >
                  <OptionButtons
                    id={questions[19].key}
                    name={questions[19].key}
                    value={localIncidentValues[questions[19].key] || 'No'}
                  />
                </FormField>

                {/* Bullying */}
                <FormField
                  label={questions[9].questionText}
                  name={questions[9].key}
                  required
                >
                  <OptionButtons
                    id={questions[9].key}
                    name={questions[9].key}
                    value={localIncidentValues[questions[9].key] || 'No'}
                  />
                </FormField>

                <Divider
                  color="primary"
                  margin={{ top: 'medium', bottom: 'small' }}
                />
                <H2 margin={{ vertical: 'none', bottom: 'small' }}>
                  Exclusions
                </H2>
                <Divider
                  color="primary"
                  margin={{ top: 'none', bottom: 'small' }}
                />
                <Box direction="row" gap="small">
                  <FormField
                    label={questions[20].questionText}
                    name={questions[20].key}
                    width="125px"
                    required
                  >
                    <OptionButtons
                      id={questions[20].key}
                      name={questions[20].key}
                      value={localIncidentValues[questions[20].key] || 'No'}
                    />
                  </FormField>

                  {localIncidentValues[questions[20].key] === 'Yes' && <FormField
                    label={questions[22].questionText}
                    name={questions[22].key}
                    required
                  >
                    <TextInput
                      name={questions[22].key}
                      type="number"
                    />
                  </FormField>}

                </Box>

                <Box direction="row" gap="small">
                  <FormField
                    label={questions[21].questionText}
                    name={questions[21].key}
                    width="125px"
                    required
                  >
                    <OptionButtons
                      id={questions[21].key}
                      name={questions[21].key}
                      value={localIncidentValues[questions[21].key] || 'No'}
                    />
                  </FormField>

                </Box>
              </>
            ) : (
              <></>
            )}

            <CommentsForm formId={props.formId} userId={props.userId} section={props.section} isCollaborator={props.allowCollaboration} />

            <Divider
              color="primary"
              margin={{ top: 'medium', bottom: 'none' }}
            />
          </Box>

          <Box
            direction="row"
            gap="small"
            justify="between"
            margin={{ top: 'medium' }}
          >
            <ActionButton label="< Back" onClick={() => previousPage()} secondary />
            <ActionButton
              icon={<FontAwesome icon={['fal', 'save']} color="#fff" />}
              label="Save for later"
              onClick={() => submitForm(localIncidentValues)}
            />
            <ActionButton label="Next Page" onClick={() => nextPage()} primary />
          </Box>
        </Form>
      </Box>
    </Box>
  );
}

export default PostIncidentLearning
